export const optionsCategory = [
  { label: "Evento", value: "Evento" },
  { label: "Lançamento jogo", value: "Lançamento jogo" },
  { label: "Novidade lojinha", value: "Novidade lojinha" },
  { label: "Promocional", value: "Promocional" },
  { label: "Evento lojinha", value: "Evento lojinha" },
];

export const optionsProfile = [
  { label: "Profissional", value: "Professional" },
  { label: "Paciente", value: "Patient" },
  { label: "Pessoal", value: "Personal" },
];

export const optionsPlan = [
  { label: "Plano Pago", value: "paid" },
  { label: "Plano Gratuito", value: "free" },
  { label: "Plano Trial", value: "trial" },
  { label: "Banner Padrão", value: "standard" },
];
